import React, { useState, useEffect } from 'react';

interface InfoMessageConfig {
  version: number;
  title: string;
  content: string | React.ReactNode; // Support pour JSX
}

const INFO_MESSAGE_STORAGE_KEY = 'infoMessageVersion';

/**
 * Hook pour gérer l'affichage des messages d'information avec système de versioning
 * @param messageConfig Configuration du message (version, titre, contenu)
 * @returns { showMessage, closeMessage } - État et fonction de fermeture
 */
export function useInfoMessage(messageConfig: InfoMessageConfig) {
  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    // Récupérer la version stockée dans localStorage
    const storedVersion = localStorage.getItem(INFO_MESSAGE_STORAGE_KEY);
    const currentVersion = storedVersion ? parseInt(storedVersion, 10) : 0;

    // Afficher le message si la version stockée est inférieure à la version actuelle
    if (currentVersion < messageConfig.version) {
      setShowMessage(true);
    }
  }, [messageConfig.version]);

  const closeMessage = () => {
    // Stocker la version actuelle dans localStorage
    localStorage.setItem(INFO_MESSAGE_STORAGE_KEY, messageConfig.version.toString());
    setShowMessage(false);
  };

  return {
    showMessage,
    closeMessage
  };
}
